const serviceConfig = {
  aws_project_region: "ap-southeast-2",
  aws_cognito_region: "ap-southeast-2",
  aws_user_pools_id: "ap-southeast-2_x2A5Lw2K3",
  aws_user_pools_web_client_id: "6n2hrsg2ldhaebtl1qt3ti4ob4",
  API: {
    endpoints: [
      {
        name: "wilcomIdApi",
        endpoint: "https://ci.api.mywilcom.link/ci"
      }
    ]
  }
};
export default serviceConfig;
